import { BlockIcon, CheckmarkCircleIcon, Flex, BscScanIcon, RefreshIcon, Column, Text } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useAppDispatch } from 'state'
import { useTranslation } from '@pancakeswap/localization'
import { TransactionDetails } from 'state/transactions/reducer'
import { pickFarmTransactionTx } from 'state/global/actions'
import { TransactionType, FarmTransactionStatus } from 'state/transactions/actions'
import { getBlockExploreLink } from 'utils'
import dayjs from 'dayjs'

interface TransactionRowProps {
  txn: TransactionDetails
  chainId: number
  type: TransactionType
  onDismiss: () => void
  chainName: string
}

const TxnIcon = styled(Flex)`
  align-items: center;
  flex: none;
  /* width: 24px; */
`

const Summary = styled.div`
  flex: 1;
  padding: 0 8px;
`

const TxnLink = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border-radius: 16px;
  background: var(--neutral-color-white-8, rgba(255, 255, 255, 0.08));
  cursor: pointer;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  margin-bottom: 16px;
  width: 100%;
  transition: opacity 0.3s ease-in-out;
  &:hover {
    text-decoration: none;
    opacity: 0.6;
  }
  .icon {
    margin-right: 2px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
  .sub-title {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    span {
      margin-right: 6px;
      font-size: 16px;
      color: #ffc9b1;
      font-weight: bold;
    }
  }
  .main-content {
    color: rgba(255, 255, 255, 0.8);
    font-weight: 500;
    padding: 0;
    font-size: 14px;
    line-height: 18px;
  }
  .time {
    p {
      color: #fff;
      font-size: 12px;
      line-height: 16px;
    }
    .state {
      margin-top: 8px;
    }
    div {
      text-align: right;
      color: rgba(255, 255, 255, 0.8);
      padding: 0;
      font-size: 14px;
      font-weight: bold;
    }
    .complete {
      color: #199a54;
    }
    .fail {
      color: #ff4338;
    }
  }
`

const renderIcon = (txn: TransactionDetails) => {
  const { receipt } = txn

  if (!txn.receipt) {
    return <RefreshIcon spin width="32px" />
  }

  const isFarmStatusSuccess = true

  return (receipt?.status === 1 && isFarmStatusSuccess) || typeof receipt?.status === 'undefined' ? (
    <CheckmarkCircleIcon color="success" width="32px" />
  ) : (
    <BlockIcon color="failure" width="32px" />
  )
}

const TRANSACTION_TYPE_MAP: Partial<Record<TransactionType, string>> = {
  approve: 'Approve',
  swap: 'Swap',
  wrap: 'Wrap',
  'add-liquidity': 'Create V2 position',
  'increase-liquidity-v3': 'increase v3 liquidity',
  'add-liquidity-v3': 'Create V3 position',
  'remove-liquidity-v3': 'Remove v3 liquidity',
  'collect-fee': 'Collect LP fee',
  'remove-liquidity': 'Remove v2 liquidity',
}

const TransactionRow: React.FC<React.PropsWithChildren<TransactionRowProps>> = ({
  chainName,
  txn,
  chainId,
  type,
  onDismiss,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const onClickTransaction = () => {
    if (type === 'non-bsc-farm') {
      onDismiss()
      dispatch(pickFarmTransactionTx({ tx: txn.hash, chainId }))
    } else {
      const url = getBlockExploreLink(txn.hash, 'transaction', chainId)
      window.open(url, '_blank', 'noopener noreferrer')
    }
  }

  if (!txn) {
    return null
  }

  return (
    <TxnLink onClick={onClickTransaction}>
      <div className="row-start">
        {/* TODO 交易记录 {txn.type} */}

        <Column style={{ gap: '8px' }}>
          <Text className="sub-title">
            {TRANSACTION_TYPE_MAP[txn.type] && <span>{TRANSACTION_TYPE_MAP[txn.type]}</span>}
            {chainName}
          </Text>
          {/* <Summary className="f-16 main-content">
          {txn.translatableSummary
            ? t(txn.translatableSummary.text, txn.translatableSummary.data)
            : txn.summary ?? txn.hash}
        </Summary> */}
          <Summary className="main-content">
            {txn.translatableSummary
              ? t(txn.translatableSummary.text, txn.translatableSummary.data)
              : txn.summary ?? txn.hash}
          </Summary>
        </Column>
      </div>
      <div className="time">
        <p>{dayjs(txn.confirmedTime).format('MMM D, YYYY h:mm A')}</p>
        <div className="state row-end">
          <TxnIcon className="icon">{renderIcon(txn)}</TxnIcon>
          {txn.receipt.status === 1 || typeof txn.receipt.status === 'undefined' ? (
            <div className="complete">Complete</div>
          ) : (
            <div className="fail">Fail</div>
          )}
        </div>
      </div>
      {/* <TxnIcon>
        <BscScanIcon width="24px" color="primary" />
      </TxnIcon> */}
    </TxnLink>
  )
}

export default TransactionRow
